import RoleType from '@/userManagement/RoleType';
import StatusType from './typelist/StatusType';

export default class Member {
  id?: string;

  role?: RoleType;

  status?: StatusType;
}
